import type { IconData } from '@stacksjs/iconify-core'

export const basicArrowsUpLeftCircle: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M2.343 13.657A8 8 0 1 0 13.657 2.343A8 8 0 0 0 2.343 13.657m2.475-8.839h5.657L9.06 6.232l2.828 2.829l-2.828 2.828l-2.829-2.828l-1.414 1.414z\" clip-rule=\"evenodd\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default basicArrowsUpLeftCircle
